<!--
* @Name：自定义卡片
* @Author: 刘玉
* @Date: 2021-12-02 15:54:54
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 15:54:54
-->
<template>
  <div class="custom-card">
    <div v-if="rowIndex" class="row-index">{{ rowIndex }}</div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'HiCard',
  props: ['rowIndex']
}
</script>
<style lang="scss" scoped>
.custom-card {
  margin: 10px;
  box-sizing: border-box;
  padding: 8px 16px;
  color: #323233;
  font-size: 17px;
  background-color: #fafafa;
  position: relative;
}
.row-index {
  position: absolute;
  height: 20px;
  line-height: 20px;
  width: 20px;
  text-align: center;
  top: -5px;
  right: -5px;
  border-radius: 2px;
  background-color: #409eff;
  color: #fff;
  font-size: 15px;
}
</style>
